import { getMemberContact } from "../../utils/memberContact";
import { actionTextColor, lightTint, readableText } from "../../utils/themeContrast";
import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { ThemeContext, LanguageContext, UserContext } from "../../contexts/Context";
import BookingTimeModal from './BookingTimeModal';
import CustomerPaymentTerm from "../customerComponents/CustomerPaymentTerm";
import axios from "axios";
import moment from 'moment';
const Modal = ({
  show,
  setShowTk,
  confirmTKCheckOut,
  lanIndex,
  deliveryType,
  dt,
  nm,
  ph,
  addr,
  rm,
  remarkValue,
  selectedCheckboxs,
  postalValue,
  unitValue,
  setDeliveryPrice,
  deliveryPrice,
  totalAmount,
  currencySymbol
}) => {
  //State
  const displayShow = show ? "grid" : "none";
  const themeContext = React.useContext(ThemeContext);
  const languageContext = React.useContext(LanguageContext);
  const { token, skipCustomerDetail, deliveryCalMethod, deliveryDisAmt, deliverySpend, weekDays, isInRoom, tableLabel, tkOrderAfter, startTime, endTime, company, customer, adCustomer, takeAwayInfo, isPreOrder } = React.useContext(UserContext);
  const { checkboxs, displayDeliveryTerm } = React.useContext(UserContext);
  const requiresDeliveryTerm = [true, "true", 1, "1"].includes(displayDeliveryTerm);
  const [deliveryTermChecked, setDeliveryTermChecked] = useState(false);
  const [showDeliveryTerm, setShowDeliveryTerm] = useState(false);
  const [deliveryTermWarning, setDeliveryTermWarning] = useState(false);
  useEffect(() => {
    if (!show) {
      setDeliveryTermChecked(false);
      setShowDeliveryTerm(false);
      setDeliveryTermWarning(false);
    }
  }, [show]);
  const [customerName, setCustomerName] = useState("");
  const [warningMsg, setWarningMsg] = useState(false);
  const [phone, setPhone] = useState("");
  let startT = moment().set("hour", moment(startTime).hour()).set("minute", moment(startTime).minute());
  const [bookingDate, setBookingDate] = useState(moment()
    .set("hour", startT.isAfter(moment()) ? moment(startTime).hour() : moment().hour())
    .set("minute", startT.isAfter(moment()) ? moment(startTime).minute() : moment().minute())
    .add(startT.isAfter(moment().add(tkOrderAfter, "minute")) ? 0 : tkOrderAfter, "minute").format("YYYY-MM-DD HH:mm")
    + " - " +
    moment()
      .set("hour", startT.isAfter(moment()) ? moment(startTime).hour() : moment().hour())
      .set("minute", startT.isAfter(moment()) ? moment(startTime).minute() : moment().minute())
      .add((startT.isAfter(moment().add(tkOrderAfter, "minute")) ? 5 : tkOrderAfter + 5), "minute").format("HH:mm")
  );
  const [address, setAddress] = useState("");
  const [postal, setPostal] = useState("");
  const [hasShowDelivery, setHasShowDelivery] = useState(false);
  const [unit, setUnit] = useState("");
  const [remark, setRemark] = useState("");
  const [showTime, setShowTime] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [room, setRoom] = useState("");
  const [selectCheckboxs, setSelectCheckboxs] = useState([]);
  // let checkboxs = ['要葱吗', '要辣吗', '一点点点'];
  const handleChange = (val, type) => {
    if (type == 'customerName') {
      setCustomerName(val)
    } else if (type == 'phone') {
      setPhone(val)
    } else if (type == 'address') {
      setAddress(val)
    } else if (type == 'unit') {
      setUnit(val)
    } else if (type == 'room') {
      setRoom(val);
    } else if (type == 'postal') {
      setPostal(val)
    } else if (type == 'remark') {
      setRemark(val)
    } else if (type == 'checkbox') {
      setSelectCheckboxs((current) => current.indexOf(val) >= 0
        ? current.filter((item) => item !== val)
        : current.concat(val));
    } else {
      setBookingDate(val)
    }
    if (customerName != "" && phone != "" && bookingDate != "" && address != "") setWarningMsg(false);
  }

  const takeawayAddress = async (formattedAddress) => {
    setWarningMsg(false);
    setErrorMsg("");

    await axios.get(`/v2/api/takeaway/address?address=${encodeURIComponent(formattedAddress)}`, { headers: { Authorization: "Bearer " + token } })
      .then(function (response) {
        setLoading(false);
        setShowTk(false);
        confirmTKCheckOut(customerName, phone, moment(bookingDate.split(' - ')[0], ["YYYY-MM-DD HH:mm", "YYYY-M-DD HH:mm", "YYYY-M-D HH:mm", "YYYY-MM-D HH:mm"], true).valueOf(), formattedAddress, remark, selectCheckboxs, deliveryType, room, postal, unit, address);
      })
      .catch(function (error) {
        setLoading(false);
     
        setErrorMsg(error.response.data.errorMsg);
        
      });
  };

  const calculateDeliveryFee = async (postal) => {
    let deliveryTime = moment(bookingDate.split(' - ')[0], ["YYYY-MM-DD HH:mm", "YYYY-M-DD HH:mm", "YYYY-M-D HH:mm", "YYYY-MM-D HH:mm"], true).valueOf();

    await axios.get(`/v2/api/takeaway/postal?postal=${postal}&deliveryTime=${deliveryTime}`, { headers: { Authorization: "Bearer " + token } })
      .then(function (response) {
        setLoading(false);
        setAddress(response.data.address);
        const baseDeliveryFee = Number(response.data.deliveryFee) || 0;
        const discount = Number(totalAmount) >= Number(deliverySpend)
          ? Number(deliveryDisAmt) || 0
          : 0;
        setDeliveryPrice(Math.max(0, baseDeliveryFee - discount), baseDeliveryFee)
        setHasShowDelivery(true);

      })
      .catch(function (error) {
        setLoading(false);
        setErrorMsg(error.response.data.errorMsg);
      });
  }

  const handleBlur = async () => {
  
    if (postal != "" && deliveryCalMethod == 1) {
      setLoading(true);
      await calculateDeliveryFee(postal);
    }
  }
  
  const isCurrentTime = (bookingDate) => {
    let date = bookingDate.split(" ")[0];

    if (date == moment().format("YYYY-MM-DD")) {
      let timeS = bookingDate.split(" ")[1];
      let timeE = bookingDate.split(" ")[3];
      let timeStampStart = moment().set("hour", parseInt(timeS.split(":")[0])).set("minute", parseInt(timeS.split(":")[1]));
      let timeStampEnd = moment().set("hour", parseInt(timeE.split(":")[0])).set("minute", parseInt(timeE.split(":")[1]));
      let now = moment();
    
      if (now.isSameOrAfter(timeStampStart) && now.isSameOrBefore(timeStampEnd)) {
        return true;
      }
    }

    return false;
  }

  useEffect(() => {
    if (show) {
      const contact = getMemberContact(customer && customer._id ? customer : adCustomer);
      setCustomerName(nm ?? takeAwayInfo?.customerName ?? contact.customerName);
      setPhone(ph ?? takeAwayInfo?.phone ?? contact.phone);
      //set as default
      if (dt)
        setBookingDate(dt);
      setAddress(addr ?? takeAwayInfo?.addressLine ?? takeAwayInfo?.address ?? "");
      setRoom(rm ?? takeAwayInfo?.roomNo ?? "");
      setRemark(remarkValue ?? takeAwayInfo?.remark ?? "");
      const savedCheckboxs = selectedCheckboxs ?? takeAwayInfo?.checkbox;
      setSelectCheckboxs(Array.isArray(savedCheckboxs) ? [...savedCheckboxs] : []);
      setPostal(postalValue ?? takeAwayInfo?.postal ?? "");
      setUnit(unitValue ?? takeAwayInfo?.unit ?? "");
      setHasShowDelivery(Boolean(postalValue ?? takeAwayInfo?.postal));

      //check if six hands
      if (company._id == "677ae529d90797dc89c7091a" || company._id == "5dc3b8d840dccce158e6f48d" || company._id == "6805bc98e75fb1ce8570ff56" ) {
        let pickUpTime = moment(bookingDate.split(' - ')[0], ["YYYY-MM-DD HH:mm", "YYYY-M-DD HH:mm", "YYYY-M-D HH:mm", "YYYY-MM-D HH:mm"], true);
        let blockTime = [];
        if (moment().isoWeekday() <= 3) {
          blockTime = [
            { startTime: moment().set("hour", 11).set("minute", 0), endTime: moment().set("hour", 14).set("minute", 30) },
            { startTime: moment().set("hour", 17).set("minute", 0), endTime: moment().set("hour", 19).set("minute", 30) },
          ];
        } else if (moment().isoWeekday() == 7) {

        } else {
          if (company._id == "6805bc98e75fb1ce8570ff56") {
            blockTime = [
              { startTime: moment().set("hour", 11).set("minute", 0), endTime: moment().set("hour", 14).set("minute", 30) },
              { startTime: moment().set("hour", 17).set("minute", 0), endTime: moment().set("hour", 19).set("minute", 30) },
            ];
          } else {
            blockTime = [
              { startTime: moment().set("hour", 11).set("minute", 0), endTime: moment().set("hour", 14).set("minute", 30) },
            ];
          }
        }

        let isWithin = false;
        for (let b of blockTime) {
          if (pickUpTime.isBetween(b.startTime, b.endTime)) {
            isWithin = true;
            break;
          }
        }


        if (!isWithin) {
          setBookingDate("");
        }

        //if today is off, then make it empty
        let tdy = moment().get("day");
        let tdyTxt = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][tdy];
        if (!weekDays || weekDays.indexOf(tdyTxt) < 0 || weekDays.length == 0) {
          setBookingDate("");
          return;
        };

      } else {
        let pickUpTime = moment(bookingDate.split(' - ')[0], ["YYYY-MM-DD HH:mm", "YYYY-M-DD HH:mm", "YYYY-M-D HH:mm", "YYYY-MM-D HH:mm"], true);

        let tdy = moment().get("day");
        let tdyTxt = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][tdy];
        if (!weekDays || weekDays.indexOf(tdyTxt) < 0 || weekDays.length == 0) {
          setBookingDate("");
          return;
        };
        let isWithin = false;
        if (pickUpTime.isBetween(moment(startTime), moment(endTime))) {
          isWithin = true;
        }
        if (!isWithin) {
          setBookingDate("");
        }
      }
    }
  }, [show]);

  const modalContent = () => {
    return (
      <React.Fragment key={0}>
        {(isInRoom && tableLabel == "In Room") &&
          <ModelWrapper>
            <ModalContentText
              fontWeight={400}
              color={"black"}
            >
              {languageContext[lanIndex].roomNo + "*"}
            </ModalContentText>
            <Input value={room} autoComplete="room" onChange={(e) => { handleChange(e.target.value, 'room') }} />
          </ModelWrapper>
        }
        {(!skipCustomerDetail || isPreOrder) &&
          <ModelWrapper>
            <ModalContentText
              fontWeight={400}
              color={"black"}
            >
              {languageContext[lanIndex].phone + "*"}
            </ModalContentText>
            <Input value={phone} type="tel" inputMode="tel" autoComplete="tel" onChange={(e) => { handleChange(e.target.value, 'phone') }} />
          </ModelWrapper>
        }

        {(!skipCustomerDetail || isPreOrder) &&
          <ModelWrapper>
            <ModalContentText
              fontWeight={400}
              color={"black"}
            >
              {languageContext[lanIndex].name}
            </ModalContentText>
            <Input value={customerName} autoComplete="name" onChange={(e) => { handleChange(e.target.value, 'customerName') }} />
          </ModelWrapper>
        }
        {(!isInRoom && !isPreOrder) &&
          <ModelWrapper>
            <ModalContentText
              fontWeight={400}
              color={"black"}
            >
              {(deliveryType == 0 || deliveryType == 1 ? languageContext[lanIndex].bookingTime : languageContext[lanIndex].deliveryTime) + "*"}
            </ModalContentText>
            <Input
              value={isCurrentTime(bookingDate) ? "Now" : bookingDate}
              readOnly
              timeField
              onClick={() => {
                setShowTime(true);
                // document.activeElement.blur();
              }}
            />
          </ModelWrapper>
        }
        {(deliveryType == 2 && !isInRoom && !isPreOrder && company._id != "69af99cff1e160b6e7187d44") &&
          <ModelWrapper>
            <ModalContentText
              fontWeight={400}
              color={"black"}
            >
              {languageContext[lanIndex].postal + "*"}
            </ModalContentText>
            <Input value={postal} inputMode="numeric" autoComplete="postal-code" onChange={(e) => { handleChange(e.target.value, 'postal') }}
              onBlur={(e) => { handleBlur(e.target.value) }}
            />
          </ModelWrapper>
        }
        {(deliveryType == 2 && !isInRoom && !isPreOrder && company._id != "69af99cff1e160b6e7187d44") &&
          <React.Fragment>
            <ModelWrapper>
              <ModalContentText
                fontWeight={400}
                color={"black"}
              >
                {languageContext[lanIndex].unitNo + "*"}
              </ModalContentText>
              <Input value={unit} autoComplete="address-line2" onChange={(e) => { handleChange(e.target.value, 'unit') }} />
            </ModelWrapper>
            <ModelWrapper>
              <ModalContentText
                fontWeight={400}
                color={"black"}
              >
                {languageContext[lanIndex].address + "*"}
              </ModalContentText>
              <Input value={address} autoComplete="street-address" onChange={(e) => { handleChange(e.target.value, 'address') }} />
            </ModelWrapper>
            {deliveryCalMethod == 1 && hasShowDelivery &&
              <FeeNotice themeContext={themeContext}>
                {`${languageContext[lanIndex].deliveryFee}: ${currencySymbol} ${deliveryPrice}`}
              </FeeNotice>
            }
            <ModelWrapper>
              <ModalContentText
                fontWeight={400}
                color={"black"}
              >
                {languageContext[lanIndex].remark}
              </ModalContentText>
              <Input value={remark} onChange={(e) => { handleChange(e.target.value, 'remark') }} />
            </ModelWrapper>
          </React.Fragment>
        }
        <CheckboxOptions>
          {
            checkboxs != null && checkboxs && checkboxs.map((item, index) => (
              <CheckboxRow key={index}>
                <Checkbox type={"checkbox"} checked={selectCheckboxs.indexOf(item) >= 0} onChange={() => { handleChange(item, 'checkbox') }} />
                <ModalText>{item}</ModalText>
              </CheckboxRow>
            ))
          }
        </CheckboxOptions>
        {requiresDeliveryTerm &&
          <DeliveryTermWrapper>
            <CheckboxRow>
              <Checkbox type="checkbox" aria-label={languageContext[lanIndex].deliveryConsent} checked={deliveryTermChecked} onChange={(event) => {
                setDeliveryTermChecked(event.target.checked);
                setDeliveryTermWarning(false);
              }} />
              <ModalText>
                {languageContext[lanIndex].deliveryConsent}{" "}
                <DeliveryTermLink type="button" onClick={() => setShowDeliveryTerm(true)}>
                  {languageContext[lanIndex].viewDetails}
                </DeliveryTermLink>
              </ModalText>
            </CheckboxRow>
            {deliveryTermWarning && <Alert role="alert">{languageContext[lanIndex].deliveryConsentWarning}</Alert>}
          </DeliveryTermWrapper>
        }

      </React.Fragment>
    );

  };

  const modalButton = () => {
    return (
      <ModalButtonContainer themeContext={themeContext}>
        <ModalConfirmButton
          type="button"
          themeContext={themeContext}
          onClick={() => {
            setShowTk(false);
            setWarningMsg(false);
          }}
        >
          <ModalText
            fontSize={15}
            fontWeight={600}
            color={themeContext.fontPrimary}
          >
            {languageContext[lanIndex].cancel}
          </ModalText>
        </ModalConfirmButton>
        <ModalConfirmButton
          type="button"
          themeContext={themeContext}
          backgroundColor={themeContext.fontPrimary}
          onClick={() => {
            if (requiresDeliveryTerm && !deliveryTermChecked) {
              setDeliveryTermWarning(true);
              return;
            }
            if ((!skipCustomerDetail || isPreOrder) && (phone == "" || phone.trim() == "" || phone.trim().length < 7 || (!isInRoom && !isPreOrder && bookingDate == ""))) {
              setWarningMsg(true);
              return;
            }
            if (!isPreOrder && !isInRoom && bookingDate == "") {
              setWarningMsg(true);
              return;
            }
            if (isInRoom && tableLabel == "In Room" && (room == "" || room.trim() == "" || room.length < 3)) {
              setWarningMsg(true);
              return;
            }
            if (deliveryType == 2 && !isInRoom && !isPreOrder && company._id != "69af99cff1e160b6e7187d44") {
              if (deliveryCalMethod == 1 && !hasShowDelivery) {
                setShowTk(false);
                setWarningMsg(true);
                return;
              }
              if (address == "") {
                setWarningMsg(true);
                return;
              }
              if (unit == "") {
                setWarningMsg(true);
                return;
              }
              if (postal == "") {
                setWarningMsg(true);
                return;
              }
              let add = "";
              if (deliveryCalMethod == 1) {
                add = address + ", " + unit + ", " + "Singapore " + postal;
              } else {
                add = unit + ", " + address + ", " + postal;
              }
              setLoading(true)
              if (deliveryCalMethod == 0) {
                takeawayAddress(add)
              } else {
                setLoading(false);
                setShowTk(false);

                confirmTKCheckOut(customerName, phone, moment(bookingDate.split(' - ')[0], ["YYYY-MM-DD HH:mm", "YYYY-M-DD HH:mm", "YYYY-M-D HH:mm", "YYYY-MM-D HH:mm"], true).valueOf(), add, remark, selectCheckboxs, deliveryType, room, postal, unit, address);

              }
            } else {

              setShowTk(false);
              setWarningMsg(false);
              confirmTKCheckOut(customerName, phone, bookingDate ? moment(bookingDate.split(' - ')[0], ["YYYY-MM-DD HH:mm", "YYYY-M-DD HH:mm", "YYYY-M-D HH:mm", "YYYY-MM-D HH:mm"], true).valueOf() : moment().valueOf(), address, remark, selectCheckboxs, deliveryType, room, postal, unit, address);
            }
          }}
        >
          <ModalText
            fontSize={15}
            fontWeight={600}
            color="#fff"
          >
            {languageContext[lanIndex].ok}
          </ModalText>
        </ModalConfirmButton>
      </ModalButtonContainer>
    );
  }


  return (
    <ModalContainer display={displayShow}>
      <ModalMain themeContext={themeContext} height={deliveryType == 0 || deliveryType == 1 ? 430 : 500}>
        <ModalHeader>
          <TitleEyebrow themeContext={themeContext}>{deliveryType == 2 ? languageContext[lanIndex].delivery : deliveryType == 1 ? languageContext[lanIndex].dineIn : languageContext[lanIndex].takeAway}</TitleEyebrow>
          <ModalHeading>{isInRoom ? languageContext[lanIndex].roomService : (deliveryType == 2 ? languageContext[lanIndex].deliveryTime : languageContext[lanIndex].bookingTime)}</ModalHeading>
        </ModalHeader>
        <ModalContent themeContext={themeContext}>
          {warningMsg &&
            <Alert role="alert">
              {isInRoom ? languageContext[lanIndex].selectRoomWarning : (deliveryType == 0 || deliveryType == 1 ? languageContext[lanIndex].selectDateWarning : languageContext[lanIndex].selectDateWarning1)}
            </Alert>
          }
          {errorMsg && errorMsg != '' &&
            <Alert role="alert">
              {errorMsg}
            </Alert>
          }
          {modalContent()}
        </ModalContent>
        {modalButton()}
      </ModalMain>
      <CustomerPaymentTerm
        show={show && requiresDeliveryTerm && showDeliveryTerm}
        setShow={setShowDeliveryTerm}
        endpoint="/v2/api/customer/delivery"
        termField="deliveryTerm"
        title={languageContext[lanIndex].deliveryTermsLabel}
      />
      {!isInRoom &&
        <BookingTimeModal show={showTime} setShowTime={setShowTime} changeBookingTime={handleChange} lanIndex={lanIndex} deliveryType={deliveryType} />
      }
      {loading && <Loading>
        <LoadingMain>
          <svg t="1659085231731" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9459" width="50" height="50"><path d="M298.666667 142.498133m-73.900835 42.666667a85.333333 85.333333 0 1 0 147.801669-85.333333 85.333333 85.333333 0 1 0-147.801669 85.333333Z" p-id="9460" fill="#f3962b"></path><path d="M142.498133 298.666667m-42.666666 73.900834a85.333333 85.333333 0 1 0 85.333333-147.801669 85.333333 85.333333 0 1 0-85.333333 147.801669Z" p-id="9461" fill="#f3962b"></path><path d="M85.333333 512m0 85.333333a85.333333 85.333333 0 1 0 0-170.666666 85.333333 85.333333 0 1 0 0 170.666666Z" p-id="9462" fill="#f3962b"></path><path d="M142.498133 725.333333m42.666667 73.900835a85.333333 85.333333 0 1 0-85.333333-147.801669 85.333333 85.333333 0 1 0 85.333333 147.801669Z" p-id="9463" fill="#f3962b"></path><path d="M298.666667 881.501867m73.900834 42.666666a85.333333 85.333333 0 1 0-147.801669-85.333333 85.333333 85.333333 0 1 0 147.801669 85.333333Z" p-id="9464" fill="#f3962b"></path><path d="M512 938.666667m-85.333333 0a85.333333 85.333333 0 1 0 170.666666 0 85.333333 85.333333 0 1 0-170.666666 0Z" p-id="9465" fill="#f3962b"></path><path d="M725.333333 881.501867m-73.900834 42.666666a85.333333 85.333333 0 1 0 147.801669-85.333333 85.333333 85.333333 0 1 0-147.801669 85.333333Z" p-id="9466" fill="#f3962b"></path><path d="M881.501867 725.333333m-42.666667 73.900835a85.333333 85.333333 0 1 0 85.333333-147.801669 85.333333 85.333333 0 1 0-85.333333 147.801669Z" p-id="9467" fill="#f3962b"></path><path d="M938.666667 512m0 85.333333a85.333333 85.333333 0 1 0 0-170.666666 85.333333 85.333333 0 1 0 0 170.666666Z" p-id="9468" fill="#f3962b"></path><path d="M881.501867 298.666667m42.666666 73.900834a85.333333 85.333333 0 1 0-85.333333-147.801669 85.333333 85.333333 0 1 0 85.333333 147.801669Z" p-id="9469" fill="#f3962b"></path><path d="M725.333333 142.498133m73.900835 42.666667a85.333333 85.333333 0 1 0-147.801669-85.333333 85.333333 85.333333 0 1 0 147.801669 85.333333Z" p-id="9470" fill="#f3962b"></path><path d="M512 85.333333m-85.333333 0a85.333333 85.333333 0 1 0 170.666666 0 85.333333 85.333333 0 1 0-170.666666 0Z" p-id="9471" fill="#f3962b"></path></svg>
        </LoadingMain>
      </Loading>}
    </ModalContainer>
  );
};

export default Modal;

const ModalContainer = styled.div`
  display: ${(props) => props.display};
  position: fixed;
  inset: 0;
  width: 100%;
  min-height: 100dvh;
  padding: 18px;
  box-sizing: border-box;
  place-items: center;
  background: rgba(15, 23, 42, 0.64);
  backdrop-filter: blur(4px);
  z-index: 20;
`;

const ModalMain = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: min(100%, 620px);
  max-height: calc(100dvh - 36px);
  border-radius: 20px;
  position: relative;
  font-family: ${(props) => props.themeContext.fontFamily};
  color: ${(props) => props.themeContext.fontPrimary};
  background: ${(props) => props.themeContext.backgroundColor || '#fff'};
  z-index: 10;
  overflow: hidden;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.3);
  animation: takeawayIn 180ms ease-out;

  @keyframes takeawayIn {
    from { opacity: 0; transform: translateY(16px) scale(0.985); }
    to { opacity: 1; transform: translateY(0) scale(1); }
  }

  @media (max-width: 600px) {
    width: calc(100% + 36px);
    max-height: calc(100dvh - 8px);
    margin: 8px -18px -18px;
    align-self: end;
    border-radius: 22px 22px 0 0;
  }
`;
const ModalHeader = styled.div`
  flex: 0 0 auto;
  padding: 22px 24px 17px;
  text-align: left;
  border-bottom: 1px solid rgba(15, 23, 42, 0.09);

  @media (max-width: 600px) { padding: 19px 18px 15px; }
`;
const TitleEyebrow = styled.div`
  margin-bottom: 4px;
  color: ${(props) => props.themeContext.fontPrimary};
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.12em;
  opacity: 0.62;
  text-transform: uppercase;
`;
const ModalHeading = styled.h2`
  margin: 0;
  font-size: 24px;
  line-height: 1.25;
`;
const ModelWrapper = styled.div`
  width: 100%;
  text-align: left;
`;
const ModalContent = styled.div`
  color: ${(props) => props.themeContext.fontPrimary};
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: 18px 24px 6px;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
  text-align: ${(props) => (props.error ? "left" : "center")};
  align-items: stretch;
  margin-top: 0px;

  @media (max-width: 600px) { padding: 16px 18px 4px; }
`;
const ModalButtonContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.35fr;
  gap: 10px;
  flex: 0 0 auto;
  padding: 14px 24px calc(18px + env(safe-area-inset-bottom));
  border-top: 1px solid rgba(15, 23, 42, 0.09);
  background: ${(props) => props.themeContext.backgroundColor || '#fff'};

  @media (max-width: 600px) { padding: 12px 18px calc(14px + env(safe-area-inset-bottom)); }
`;

const ModalConfirmButton = styled.button`
  background-color: ${props => props.backgroundColor || lightTint(props.themeContext.primaryColor, .06)};
  color: ${props => props.backgroundColor
    ? actionTextColor(props.themeContext, props.backgroundColor)
    : readableText(lightTint(props.themeContext.primaryColor, .06), "#333333")};
  > span { color: inherit; }
  min-height: 50px;
  padding: 0 16px;
  text-align: center;
  border-radius: 12px;
  border: 1px solid;
  border-color: ${props => props.backgroundColor || lightTint(props.themeContext.primaryColor, .3)};
  font-family: inherit;
  cursor: pointer;
`;

const ModalContentText = styled.div`
  margin-bottom: 7px;
  color: ${(props) => (props.color ? props.color : "black")};
  font-size: 13px;
  font-weight: 750;
  line-height: 17px;
`;

const ModalText = styled.span`
  align-self: center;
  justify-content: center;
  text-align: ${(props) => (props.textAlign ? props.textAlign : "left")};
  color: ${(props) => (props.color ? props.color : "black")};
  font-size: ${(props) => props.fontSize ? `${props.fontSize}px` : '14px'};
  font-weight: ${(props) => props.fontWeight};
  padding-left: ${(props) => (props.margin ? props.margin : 0)}px;
  padding-right: ${(props) => (props.margin ? props.margin : 0)}px;
`;

const InputText = styled.div`
  height: 46px;
  border-radius: 11px;
  padding: 0 14px;
  font-size: 15px;
  border: 1px solid #d0d5dd;
  margin-bottom: 15px;
`;
const Input = styled.input`
  width: 100%;
  height: 46px;
  box-sizing: border-box;
  border-radius: 11px;
  padding: 0 14px;
  color: #101828;
  background: ${(props) => props.readOnly ? '#f8fafc' : '#fff'};
  font-family: inherit;
  font-size: 15px;
  border: 1px solid #d0d5dd;
  margin-bottom: 15px;
  cursor: ${(props) => props.timeField ? 'pointer' : 'text'};
  transition: border-color 140ms ease, box-shadow 140ms ease;

  &:focus {
    outline: none;
    border-color: #667085;
    box-shadow: 0 0 0 3px rgba(102, 112, 133, 0.14);
  }
`;
const Alert = styled.div`
  margin-bottom: 14px;
  padding: 11px 13px;
  border: 1px solid #fecdca;
  border-radius: 10px;
  color: #b42318;
  background: #fef3f2;
  font-size: 13px;
  font-weight: 650;
  line-height: 1.4;
  text-align: left;
`;
const FeeNotice = styled.div`
  margin-bottom: 15px;
  padding: 11px 13px;
  border-radius: 10px;
  color: ${(props) => props.themeContext.fontPrimary};
  background: rgba(15, 23, 42, 0.055);
  font-size: 13px;
  font-weight: 800;
`;
const CheckboxOptions = styled.div`
  display: grid;
  gap: 8px;
  margin-bottom: 10px;
`;
const DeliveryTermWrapper = styled.div`
  margin-bottom: 14px;
  text-align: left;
`;
const DeliveryTermLink = styled.button`
  border: 0;
  padding: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-decoration: underline;
  cursor: pointer;
`;
const CheckboxRow = styled.label`
  display: flex;
  min-height: 42px;
  padding: 7px 10px;
  box-sizing: border-box;
  align-items: center;
  border: 1px solid #e4e7ec;
  border-radius: 10px;
  background: #fafafa;
  cursor: pointer;
`;

const Loading = styled.div`
  position: fixed;
  inset: 0;
  width: 100%;
  min-height: 100dvh;
  background: rgba(255, 255, 255, 0.58);
  backdrop-filter: blur(2px);
  z-index: 40;
`;

const LoadingMain = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 100dvh;

  svg { animation: spin 900ms linear infinite; }
  @keyframes spin { to { transform: rotate(360deg); } }
`;

const Checkbox = styled.input`
  height: 20px;
  width: 20px;
  flex: 0 0 auto;
  accent-color: #344054;
  margin: 5px 12px 5px 2px;
`
